export const RECOMMENDATIONS_LIMITED_RESULT = 'Cars_RecommendationsLimitedResults';
export const INLINE_MAPS_OFF_AIRPORT_SEARCH_MWEB = 'Cars_InlineMapMweb';
export const DROPOFF_PINS_MAP = 'Cars_UpdateOneWayMaps_EGTNL';

export const CARS_SALEEXPERIENCE = 'Cars_SalesExperience';
export const BERNIE_CARS_EGTP = 'bernie-cars-egtp';
export const BERNIE_CARS_LEGACY = 'bernie-cars-legacy';
export const CAR_EGTP_M2_EXPEDIA = 'Cars_EGTP_M2_Expedia';
export const CAR_EGTP_M2 = 'Cars_EGTP_M2';
export const CAR_FLOATING_CTA = 'Cars_FloatingCTA_EGTNL';
export const CARS_BERNIE_EGTL_AA = 'Cars_Bernie_EGTL_AA';
export const CARS_RADIO_BUTTONS_SORT = 'Cars_RadioButtonsForSort_EGTNL';
export const  CARS_DISPLAY_REVIEW_COMMENTS = 'Cars_DisplayreviewcommentsEGTNL';
export const CARS_UPDATE_REFRESH_MESSAGE = 'Cars_Updatedrefreshmessage_EGTNL';
export const ONE_KEY_BANNER_CARS_CSR = 'OneKey_Cars_EGTnL';
export const ONE_KEY_BANNER_PACKAGES_CSR = 'TSDP_OneKey_Anon_HSRFSRCSR_Web';
